"use strict";

var PropTypes = require("prop-types");

var LoggerInstance = require("js-logger").get("Frequency");
var React = require("react");

var CheckoutActions = require("./CheckoutActions");
var CheckoutStore = require("./CheckoutStore");

class Frequency extends React.Component {
	constructor(props) {
		super(props);

		var state = this.getStateFromStore(props);
		var wizardFrequencies = CheckoutStore.get("wizardFrequencies") || { allowedFrequencies: [] };
		var allowedFrequencies = wizardFrequencies.allowedFrequencies || [];
		var frequencies = props.frequencies;
		var frequency;

		if (allowedFrequencies && frequencies) {
			for (var i = frequencies.length - 1; i >= 0; --i) {
				frequency = frequencies[i];
				var allowedIndex = allowedFrequencies.indexOf(frequency.value);
				if (allowedIndex === -1) {
					// Frequency is not allowed
					frequencies.splice(i, 1);
				} else if (frequency.useDefaultDescription) {
					// Frequency should use default description
					frequency.description = wizardFrequencies[`${frequency.value}_Description`];
				}
			}
		} else {
			frequencies = [];
		}

		state.frequencies = frequencies;

		this.state = state;

		this._onChange = this._onChange.bind(this);
	}

	handleChange(event) {
		var cartItemId = this.props.cartItemId;
		CheckoutActions.setDonationFrequency(cartItemId, event.currentTarget.value);
		CheckoutActions.updateDonation(cartItemId);
	}

	getStateFromStore(props) {
		return {
			selectedFrequency: CheckoutStore.getDonationFrequency((props || this.props).cartItemId)
		};
	}

	_onChange() {
		this.setState(this.getStateFromStore());
	}

	componentDidMount() {
		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentLoaded(this);
		}
		CheckoutStore.addChangeListener(this._onChange);
	}

	componentWillUnmount() {
		CheckoutStore.removeChangeListener(this._onChange);

		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentUnloaded(this);
			CheckoutActions.setDonationFrequency(this.props.cartItemId, null);
		}
	}

	render() {
		var selectedFrequency = this.state.selectedFrequency;
		var frequencies = this.state.frequencies;

		return (
			<span
				data-react-component-name="Frequency"
				data-react-component-category="DonationCartItemComponents"
				data-component-id={this.props.dataComponentId}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
			>
				<select
					value={selectedFrequency || ""}
					onChange={this.handleChange.bind(this)}
					className={this.props.className}
					style={this.props.isDesignMode ? {"pointerEvents": "none"} : undefined}
					data-override-classes={this.props.className}
				>
					{frequencies && frequencies.map(frequency => {
						return (
							<option key={frequency.value} value={frequency.value}>
								{frequency.description}
							</option>
						);
					})}
				</select>
			</span>
		);
	}
}

Frequency.defaultProps = {};

Frequency.propTypes = {
	className: PropTypes.string,
	isDesignMode: PropTypes.bool,
	cartItemId: PropTypes.string,
	frequencies: PropTypes.arrayOf(PropTypes.shape({
		description: PropTypes.string,
		value: PropTypes.string
	})),
	theme: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string
};

module.exports = Frequency;
